import { FONT } from '@farewill/ui/tokens'
import styled from 'styled-components'

const GridColumn = styled.li`
  font-size: ${FONT.SIZE.S};
`

export default GridColumn
